import { render, staticRenderFns } from "./CarLifeBadainJaran.vue?vue&type=template&id=4cb2dea4&scoped=true"
import script from "./CarLifeBadainJaran.vue?vue&type=script&lang=js"
export * from "./CarLifeBadainJaran.vue?vue&type=script&lang=js"
import style0 from "./CarLifeBadainJaran.vue?vue&type=style&index=0&id=4cb2dea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2dea4",
  null
  
)

export default component.exports